import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Qna.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
// import Right from '../right/Right';
import Service from '../service/Service';
import Question from './common/Question';
import UserListOverlay from './common/UserListOverlay';
import AnswerOverlay from './common/AnswerOverlay';
import QuestionOverlay from './common/QuestionOverlay';
import ModerationOverlay from './common/ModerationOverlay';

const service = new Service();

class Qna extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        this.totalCount = 0;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['QuestionData']) {
            initialData = serverSideData['QuestionData']['QuestionInfo'];
            this.totalCount = parseInt(serverSideData['QuestionData']['totalCnt']);
        }
        if (global.userAry['childData']['UserChildList']) {
            var childData = global.userAry['childData']['UserChildList'].filter(function (item) {
                return !item.IsExpected;
            });
        }
        // if(childData.length == 1){
        //     var default_child_id = childData[0].ChildId;
        // } else {
        //     if(childData.length <= 0){
        //         var default_child_id = "all";
        //     } else {
        //         var default_child_id = 0;
        //     }
        // }
        if(childData){
            var default_child_id = childData[0] && childData[0].ChildId ? childData[0].ChildId : '';
        } else {
            if(!childData){
                var default_child_id = "all";
            } else {
                var default_child_id = 0;
            }
        }

        this.state = {
            initialData: initialData,
            metaTitle: "Questions & Answers: Pregnancy, Baby Care, Parenting Tips & Advice",
            metaDescription: [],
            childIdQuePost: default_child_id
        };

        // console.log(this.state);

        this.qnaPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.match.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
        this.urlHash = this.props.location.hash;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        var url = global.api_url + "getquestiondataDes";
        
        let body = JSON.stringify({
            "pagesize": size,
            "pageno": 1,
            "qnaUserType": "0"
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        // if (this.props.location.search.includes('from=app')) {
        //     document.getElementsByClassName('snackbar')[0].style.bottom = '0';
        // }
        // service.disableCutCopyPaste('post_answer_text');
        // service.disableCutCopyPaste('post_question_text');
        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        service.loadImages();
        if (navigator.onLine) {
            let size = 10;
            if (this.qnaPageNo > 1) {
                size = 10 * this.qnaPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.qnaData(1, size);
            } else {
                localStorage.setItem('qnaLanding', JSON.stringify(this.state.initialData));
                localStorage.setItem('qnaLandingCnt', JSON.stringify(this.totalCount));
                actions.loadReadMore();
            }
        } else {
            if (localStorage.getItem('qnaLanding')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('qnaLanding')) }, () => { service.loadImages(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('qnaLandingCnt')) {
                this.totalCount = localStorage.getItem('qnaLandingCnt');
            }
            service.hideLoader();
        }
        if (this.urlHash && this.urlHash != '') {
            actions.openQuestionPopup();
            document.getElementById('post_question_text').value = this.urlHash.trim() + " ";
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        service.showTracking();
                document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.qnaData(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    qnaData(pageno, size) {
        var url = global.api_ci_url + "Qna/getquestiondataDes";
        let postData = {
            "pagesize": size,
            "pageno": pageno,
            "qnaUserType": "0"
        }
        service.postServiceCall(url, postData).then((json) => {
            
            if (json['msg'] == "1") {
                if (this.state.initialData && this.state.initialData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ initialData: json['QuestionData']['QuestionInfo'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.initialData;
                        this.setState({ initialData: ary.concat(json['QuestionData']['QuestionInfo']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('qnaLanding', JSON.stringify(json['QuestionData']['QuestionInfo']));
                    localStorage.setItem('qnaLandingCnt', JSON.stringify(json['QuestionData']['totalCnt']));
                    this.totalCount = parseInt(json['QuestionData']['totalCnt']);
                    this.setState({ initialData: json['QuestionData']['QuestionInfo'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    qnaReloadData(queId, ansId) {
        
        var url = global.api_ci_url + "Qna/getMyQNADetailsDes";
        let postData = {
            "pagesize": 10,
            "pageno": 1,
            "question_id": queId
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                let dataAry = this.state.initialData;
                for (let d = 0; d < dataAry.length; d++) {
                    
                    if (dataAry[d]['question_id'] == queId) {
                        let ansObj = [];
                        if (json['QuestionData'][0]['answers'] && json['QuestionData'][0]['answers'].length > 0) {
                            if (ansId != 0) {
                                ansObj = json['QuestionData'][0]['answers'].filter(function (item) {
                                    return ansId == item.answer_id;
                                });
                            } else {
                                ansObj.push(json['QuestionData'][0]['answers'][0]);
                            }
                        }
                        dataAry[d] = json['QuestionData'][0];
                        dataAry[d]['question_id'] = queId;
                        dataAry[d]['answers'] = ansObj;

                    }
                }
                this.setState({ initialData: dataAry }, () => { service.loadImages(); actions.loadReadMore(); });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    reloadData(queId, ansId) {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.qnaReloadData(queId, ansId);
        }, 500)
    }

    render() {
        return (
            <main className="qna-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Questions & Answers</span>
                    </div>
                    <h1 className="B24_00">Q&A</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="askAQues loginwindow">
                            <div className="q4 askque-title">Want to share your parenting queries and get answers</div>
                            <div className="q8 askque-text">Get Solutions and advice from other parents and experts</div>
                            <span className="ask-a-que-btn" id="devaskQuestion">
                                <span className="b_1 ask-a-que-btn">
                                    <span className="ask-a-que-btn">Ask a Question</span>
                                </span>
                            </span>
                        </div>

                        <div className="mb-15">
                            {this.state.initialData && this.state.initialData.length > 0 &&
                                <Question questions={this.state.initialData} isLanding={true} isShowAbuse={true} checkQId={''} eleRef={this} isSimilarQue={false} isShowReadMore={true} />
                            }
                            {(!this.state.initialData || this.state.initialData.length < 1) &&
                                <div className="question-block"></div>
                            }
                            <input type="hidden" id="pgNo" value="" />
                        </div>
                    </div>
                </div>
                <div className="snackbar" onClick={() => actions.openQuestionPopup()} id="devaskQuestion">
                    <div className="askquebtn">
                        <div data-icon-font="" className="icon"></div>
                        <span className="ask-quen">Ask a Question</span>
                    </div>
                </div>
                <UserListOverlay eleRef={this} />
                <AnswerOverlay eleRef={this} />
                <QuestionOverlay eleRef={this} childData={global.userAry['childData']['UserChildList']} />
                <ModerationOverlay />
                {/* <Right url={this.props.match.url} /> */}
            </main>
        )
    }
}

export default Qna;



// WEBPACK FOOTER //
// src/shared/qna/Qna.js